import { Finding } from '@consigli/types';
import { FC, useState } from 'react';
import { FaChevronDown, FaChevronRight, FaArrowUpRightFromSquare } from 'react-icons/fa6';
import { Link } from 'react-router';

import { SummaryFindingRow } from './summary-finding-row';

export interface SummarySectionAccordionProps {
  heading: string;
  body: string;
  findings: Finding[];
  findingCount?: number;
  findingsHref?: string;
}

export const SummarySectionAccordion: FC<SummarySectionAccordionProps> = ({
  heading,
  body,
  findings,
  findingCount,
  findingsHref,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <li className="list-none">
      <div className="flex items-start w-full hover:bg-day-light-3 transition-colors bg-day-light-5">
        <button
          className="flex items-start grow px-5 py-3.5 text-left cursor-pointer gap-2.5"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="mt-1 shrink-0 text-day-neutral-subtle">
            {open ? <FaChevronDown size={11} /> : <FaChevronRight size={11} />}
          </span>
          <span className="grow text-sm leading-snug min-w-0">
            <span className="inline-flex items-center gap-2 flex-wrap">
              <span className="font-semibold text-day-neutral-dark">{heading}</span>
              <span className="inline-flex items-center justify-center min-w-5 h-5 px-1 rounded-full bg-day-light-2 text-xs font-medium text-day-neutral-subtle leading-none shrink-0">
                {findingCount ?? findings.length}
              </span>
            </span>
            {body && (
              <span className="block mt-1 text-day-neutral-subtle text-xs leading-relaxed wrap-break-word whitespace-normal">
                {body}
              </span>
            )}
          </span>
        </button>
        {findingsHref && (
          <Link
            to={findingsHref}
            className="pt-[18px] pr-5 shrink-0 text-day-neutral-subtle hover:text-day-primary transition-colors"
          >
            <FaArrowUpRightFromSquare size={10} />
          </Link>
        )}
      </div>

      {open && findings.length > 0 && (
        <div className="bg-day-light-3 border-t border-day-light-2">
          <ul className="flex flex-col gap-2 px-5 py-4 pl-9">
            {findings.map((finding) => (
              <SummaryFindingRow key={finding.id} finding={finding} />
            ))}
          </ul>
        </div>
      )}
    </li>
  );
};
